<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4>Add event</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class="px-1 pt-0">
    <div class="container event-section px-2 py-0">
      <div class="row ">
        <div class="col-12">
          <h3 class="title text-center">Select Services</h3>
        </div>
      </div>
      <div class="row session-box event-list" *ngIf="isEventDataAvailable">
        <div class="col-md-12 session-textbox position-relative p-0">
          <div class="session-search">
            <input maxlength="100" type="text" (keyup)="applyFilter($event)" placeholder="Search"
              class="form-control search-box" [(ngModel)]="searchString"
              oninput="this.value = this.value.replace(/^\s+/g, '')" />
            <i *ngIf="searchString !== ''" class="fa-solid fa-times search-icon" (click)="clearSearch()"></i>
            <i *ngIf="searchString === ''" class="fa-solid fa-magnifying-glass search-icon"></i>
          </div>
        </div>
      </div>
      <section id="events-card" [ngClass]="{'no-record': eventList.length == 0}">
        <div class="container">
          <div class="row row-cols-1 row-cols-md-2 g-4 mt-2">
            <div class="col-lg-6 col-md-12 col-12 mb-3 mt-0" *ngFor="let event of eventList">
              <div class="card" (click)="event.isSoldOut ? null : eventAddConfirmation(event)">
                <div class="card-header pb-0">
                  <h5 class="event-box WrapData" title="{{event.name}}">{{event.name}}</h5>
                  <h6 class="ribbon sold-out" *ngIf="event.isSoldOut && event.isBooked == 0">
                    <span>Sold Out </span>
                  </h6>
                  <h6 class="ribbon booked" *ngIf="event.isBooked > 0">
                    <span>Booked</span>
                  </h6>
                  <h6 class="ribbon" *ngIf="event.isSoldOut == false && event.isBooked == 0">
                    <span>Book now </span>
                  </h6>
                </div>
                <div class="card-body pt-1">
                  <img [src]="event.images ? event.images :'../../../../../assets/img/default-event.svg'"
                    (error)="eventImageErrorHandler(event)" class="card-img-top img-fluid" alt="..." />
                  <div class="card-one float-start mt-4">
                    <h6 class="card-title">
                      <img src="../../../assets/icons/event_calender_icon.svg " alt>
                      <span [innerHTML]="event.startDateTime | ordinalDate : event.endDateTime"></span>
                    </h6>
                    <h6 class="card-title">
                      <i class="fa-regular fa-clock clock-img"></i>
                      <span
                        [title]="(event.startDateTime |date:dateFormat.shortTime) + '-' + (event.endDateTime | date:dateFormat.shortTime)"
                        class="date">{{event.startDateTime
                        |date:dateFormat.shortTime }} -
                        {{event.endDateTime |
                        date:dateFormat.shortTime }}</span>
                    </h6>
                  </div>
                  <div class="card-two ms-auto position-relative">
                    <button type="button" class="btn btn-dark"><sup>{{currency.pound}}</sup>{{event.fees}}</button>
                    <h6 class="text-heading  mt-c-4">
                      <img class="me-1" src="../../../assets/icons/event_location_icon.svg" alt> {{event.eventAddress}}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2 pb-3">
            <div *ngIf="eventList.length == 0" class="text-center">
              No event record found!
            </div>
          </div>
        </div>
      </section>
      <div class="mt-2" *ngIf="eventList.length > 0">
        <mat-paginator [length]="totalrecord" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          aria-label="Select page" (page)="pageChanged($event)" [showFirstLastButtons]="true">
        </mat-paginator>
      </div>
    </div>
    <div class="mt-3 text-center">
      <button class="btn btn-primary-outline previous-btn" (click)="cancel()" title="Add New Order">
        Previous
      </button>
    </div>
  </mat-dialog-content>
</div>